/* iCandy World — scroll reveal (progressive enhancement).
   Sections render fully visible without JS; this only animates them in
   once support is confirmed. Honours prefers-reduced-motion and rebinds
   when sections are (re)loaded in the Shopify theme editor. */
(function () {
  // Several sections include this script; only wire up once.
  if (window.__icandyReveal) return;
  window.__icandyReveal = true;
  var root = document.documentElement;
  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('js-reveal');

  var io = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function bind(scope) {
    (scope || document).querySelectorAll('.reveal:not(.is-bound)').forEach(function (el) {
      el.classList.add('is-bound');
      io.observe(el);
    });
  }

  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', function () { bind(); });

  // Theme editor: re-scan when a section is added/reloaded.
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
